import { GET_ASSETS_LIST, GET_ASSETS_LIST_ERROR, GET_ASSETS_LIST_REQUEST, UPDATE_ASSETS_LIST_DATA, REMOVE_ASSETS_LIST } from "../ActionTypes/ActionTypes.js";

const initialState = {
    assetListLoading: false,
    assetListData: null,
    assetListError: null,
    assetListStatus: null,
    isModified: false,
    isFirstLoad: true,


};

const assetListReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_ASSETS_LIST_REQUEST:
            return { ...state, assetListLoading: state.isFirstLoad, assetListStatus: null, assetListData: null };
        case GET_ASSETS_LIST:
            return {
                assetListLoading: false, assetListData: action.payload, assetListError: null, assetListStatus: true,

                isFirstLoad: false,
            };

        case GET_ASSETS_LIST_ERROR:
            return { assetListLoading: false, assetListData: null, assetListError: action?.payload, assetListStatus: false, isFirstLoad: false, };
        case UPDATE_ASSETS_LIST_DATA:
            return {
                ...state,
                assetListData: {
                    ...state.assetListData,
                    result: {
                        ...state.assetListData.result,
                        ...action.payload,
                    },
                },
            };
        case REMOVE_ASSETS_LIST:
            return { ...state, assetListData: null, assetListError: null, isModified: false, assetListStatus: null, isFirstLoad: true, assetListLoading: false }
        default:
            return state;
    }
};

export default assetListReducer;